export default __webpack_public_path__ + "static/media/bh7.098ca7ea.jpg";